(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracSourceDialogController', NasracSourceDialogController);

    NasracSourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NasracSource', 'NasracSourceType'];

    function NasracSourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NasracSource, NasracSourceType) {
        var vm = this;

        vm.nasracSource = entity;
        console.log(vm.nasracSource.id);
        vm.isSave=false;
        if(vm.nasracSource.id==null)
        {
            vm.isSave=true;
        }
        vm.clear = clear;
        vm.save = save;
        vm.nasracsourcetypes = NasracSourceType.query();

        $timeout(function (){
            if(vm.isSave)
                angular.element('.form-group:eq(0)>input').focus();
            else
                angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if (vm.isSave) {
                NasracSource.save(vm.nasracSource, onSaveSuccess, onSaveError);
            } else {
                NasracSource.update(vm.nasracSource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('nasracApp:nasracSourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
